<template>
  <md-card>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-xsmall-size-100">
          <md-field>
            <label for="crew" v-if="roadSinister.crew">Cuadrilla</label>
            <label for="crew" v-else>Asignar cuadrilla</label>
            <md-select v-model="roadSinister.crew">
              <md-option v-for="crew in crews" :key="crew.id" :value="crew.id">{{ crew.name }}</md-option>
            </md-select>
            <md-button @click="roadSinister.crew = null" v-if="roadSinister.crew">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>
      </div>

      <template v-if="crew.id">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-card>
              <md-card-header>
                <h3>{{ crew.name }}</h3>
              </md-card-header>

              <md-card-content>
                <div class="md-layout">
                  <f-field label="Residente de vialidades" :value="crew.attendant || 'text'"></f-field>
                </div>
                <div class="md-layout">
                  <catalog-table
                    title="Workers"
                    :tableHeaders="workersHeaders"
                    :tableData="crew.workers"
                    :propsToSearch="workersSearchableProps"
                  ></catalog-table>
                </div>
              </md-card-content>
            </md-card>
          </div>
        </div>
      </template>
    </md-card-content>
  </md-card>
</template>

<script>
import { CatalogTable } from "@/components";
import catalogService from "@/services/catalog";
import FField from "./FField";

export default {
  name: "Crew",

  props: {
    roadSinister: {
      type: Object,
      required: true,
    },
    // crew: {
    //   type: Object,
    //   required: true
    // }
  },

  components: {
    FField,
    CatalogTable,
  },

  data() {
    return {
      workersHeaders: {
        name: "Nombre",
        typeOfWorker: "Tipo",
      },
      workersSearchableProps: ["name"],
      crews: [],
      crew: {},
    };
  },

  mounted() {
    catalogService.fetch("crew", { noStore: true }).then((crews) => {
      this.crews = crews;
    });
  },

  watch: {
    "roadSinister.crew": function (crewId) {
      if (!crewId) {
        this.crew = {};
        return;
      }
      const crew = this.crews.filter((crew) => crew.id == crewId)[0];
      this.crew = crew;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/Crew.vue